import Confirm from '../components/dialogs/Confirm.vue'

export default function (Vue, options = {}) {
  const vuetify = options.vuetify
  delete options.vuetify

  const ConfirmComponent = Vue.extend(Object.assign({ vuetify }, Confirm))

  function confirm (message, options = {}) {
    options.message = message

    const container = document.querySelector('[data-app=true]') || document.body

    const confirmInstance = new ConfirmComponent(Object.assign({}, {
      propsData: Object.assign({}, Vue.prototype.$confirm.options, options),
      destroyed: function () {
        container.removeChild(this.$el)
      },
      mounted: function () {
        container.appendChild(this.$el)
      }
    })).$mount()

    return confirmInstance.show().then((result) => {
      confirmInstance.$destroy()
      return result
    })
  }

  Vue.$confirm = confirm
  Vue.prototype.$confirm = confirm
  Vue.prototype.$confirm.options = options
}
